import { Component, HostListener, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-navbar',
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './navbar.html',
  styleUrl: './navbar.css'
})
export class Navbar {
  private router = inject(Router);

  // Hide the "Get Started" CTA on the standalone landing page only.
  get isLandingPage(): boolean {
    return this.router.url.split(/[?#]/)[0] === '/landing';
  }

  isMenuOpen = false;
  activeDropdown: string | null = null;
  activeMobileDropdown: string | null = null;

  menuItems = [
    { path: '/', label: 'Home', exact: true },
    { path: '/about', label: 'About', exact: false },
    { path: '/blog', label: 'Blog', exact: false },
    { path: '/contact', label: 'Contact', exact: false }
  ];

  services = [
    {
      label: 'Marketing',
      path: '/performance-marketing',
      description: 'Performance Marketing Solutions',
      children: [
        { path: '/performance-marketing/paid-ads', label: 'Paid Ads' },
        { path: '/performance-marketing/analytics', label: 'Analytics' },
        { path: '/performance-marketing/cro', label: 'CRO' },
        { path: '/performance-marketing/seo', label: 'SEO' },
        { path: '/performance-marketing/automation', label: 'Automation' },
        { path: '/performance-marketing/lead-generation', label: 'Lead Generation' },
        { path: '/performance-marketing/social-media', label: 'Social Media' }
      ]
    },
    {
      label: 'Compliance',
      path: '/cloud-compliance',
      description: 'Cloud Compliance Services',
      children: [
        { path: '/cloud-compliance/pci', label: 'PCI DSS' },
        { path: '/cloud-compliance/soc2', label: 'SOC 2' },
        { path: '/cloud-compliance/hipaa', label: 'HIPAA' },
        { path: '/cloud-compliance/iso27001', label: 'ISO 27001' },
        { path: '/cloud-compliance/gdpr', label: 'GDPR' }
      ]
    },
    {
      label: 'DevOps',
      path: '/devops',
      description: 'DevOps & Automation',
      children: [
        { path: '/devops/cicd', label: 'CI/CD' },
        { path: '/devops/iac', label: 'Infrastructure as Code' },
        { path: '/devops/containers', label: 'Containers' },
        { path: '/devops/devsecops', label: 'DevSecOps' },
        { path: '/devops/monitoring', label: 'Monitoring' },
        { path: '/devops/finops', label: 'FinOps' }
      ]
    },
    {
      label: 'Messaging',
      path: '/messaging',
      description: 'Enterprise Messaging',
      children: [
        { path: '/messaging/bulk-sms', label: 'Bulk SMS' },
        { path: '/messaging/bulk-email', label: 'Bulk Email' },
        { path: '/messaging/bulk-whatsapp', label: 'Bulk WhatsApp' },
        { path: '/messaging/rcs', label: 'RCS' },
        { path: '/messaging/whatsapp-api', label: 'WhatsApp API' }
      ]
    }
  ];

  activeService: string | null = null;

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    if (!this.isMenuOpen) {
      this.activeMobileDropdown = null;
    }
  }

  closeMenu() {
    this.isMenuOpen = false;
    this.activeMobileDropdown = null;
  }

  openDropdown(label: string) {
    this.activeDropdown = label;
  }

  closeDropdown() {
    this.activeDropdown = null;
  }

  toggleMobileDropdown(label: string) {
    this.activeMobileDropdown = this.activeMobileDropdown === label ? null : label;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown-container')) {
      this.activeDropdown = null;
    }
  }
}
